import ReactDOM from 'react-dom/client';

//
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// ----------------------------------------------------------------------

// ResizeObserver 무한 루프 경고 무시 (MUI DataGrid 등 라이브러리에서 발생하는 무해한 경고)
// 에러 메시지 확인 함수
const isResizeObserverError = (message: string | Event): boolean => {
  const msg = typeof message === 'string' ? message : (message as ErrorEvent)?.message || '';
  return msg.includes('ResizeObserver loop');
};

// window.onerror 핸들러
const resizeObserverErr = window.onerror;
window.onerror = (message, ...args) => {
  if (isResizeObserverError(message as string)) {
    return true;
  }
  return resizeObserverErr ? resizeObserverErr(message, ...args) : false;
};

// error 이벤트 핸들러
window.addEventListener('error', (e) => {
  if (isResizeObserverError(e.message)) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

// unhandledrejection 이벤트 핸들러
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason?.message && isResizeObserverError(e.reason.message)) {
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWAW
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
